import React, { createContext } from "react";

const AmazonIdeaContext = createContext(null);
export function AmazonIdeaProvider({ children, ...props }) {
  const bag = React.useMemo(() => ({ ...props }), [...Object.values(props)]);

  return (
    <AmazonIdeaContext.Provider value={bag}>
      {children}
    </AmazonIdeaContext.Provider>
  );
}


export function useAmazonIdeaCtx() {
    return React.useContext(AmazonIdeaContext);
}